import './index.scss';

import React from 'react';
import modifiers from '../../../util/components';

import Icon from '../icon/index';

export default class Button extends React.Component {
    
    static defaultProps = {
        text: '',
        icon: null,
        modifiers: [],
        active: false,
        disabled: false,
        type: 'button',
        style: null,
        onClick: () => {
        },
    };
    
    constructor(props) {
        super(props);
    }
    
    render() {
        let icon;
        let modifiersList = [this.props.modifiers];
        
        if (this.props.modifiers instanceof Array) {
             modifiersList = [...this.props.modifiers];
        }
        
        if (this.props.icon) {
            icon = (
                <div className="button__icon">
                    {(this.props.modifiers.includes('outline') || this.props.modifiers.includes('transparent')) ? (
                            <Icon type={this.props.icon}/>
                        ) :
                        <Icon modifiers={['extra-dim']} type={this.props.icon}/>
                    }
                </div>
            );
        }
        
        if (this.props.disabled) {
            modifiersList.push('disabled');
        }
        
        return (
            <button
                type={this.props.type}
                className={'button' + modifiers('button', modifiersList)}
                onClick={(event) => this.props.onClick(event)}
                style={this.props.style}
                value={this.props.text}
                disabled={this.props.disabled}
            >
                {icon}
                {this.props.text}
            </button>
        );
    }
}